// @flow

import { type IncomingPayment, getMerchant } from '@tectonics/prs/incoming-payment';
import type { WithholdTaxes } from '@tectonics/prs/argentina/withhold-taxes/types';
import { getName as getMerchantName } from '@tectonics/prs/merchant';

export function getWithholdTaxes(incomingPayment: IncomingPayment, amount: string): WithholdTaxes {
  const merchant = getMerchant(incomingPayment);
  const merchantName = getMerchantName(merchant);

  const withholdTaxes: WithholdTaxes = {
    amount,
    merchantName,
  };

  return withholdTaxes;
}
